import React, { useEffect } from "react";
import DonationList from "./DonationList";
import OrderTotal from "./OrderTotal";
import FrequencyToggle from "./FrequencyToggle";
import "./GivingApp.scss";
import "./CheckoutPage.scss";
import "../spinner.scss";
import { useAppContext } from "../hooks/useAppContext";
import {
  getCampaignPath,
  getWebformSubmission,
} from "../services/funds.service";
import { hasEmptyAmount } from "../services/cart.service";
import WebFormSubmission from "./WebFormSubmission";

const Checkout = ({ checkoutForm }) => {
  const {
    openMenu,
    frequency,
    setFrequency,
    items,
    total,
    isLoading,
    isMobile,
  } = useAppContext();
  const [editStateItems, setEditStateItems] = React.useState(null);
  const [readyCheckout, setReadyCheckout] = React.useState(true);
  const [title, setTitle] = React.useState("");
  const webformSubmission = getWebformSubmission();

  useEffect(() => {
    const pluralTitle = items.length > 1 ? "Gifts" : "Gift";
    setTitle(isMobile ? `Complete Your ${pluralTitle}` : `Your ${pluralTitle}`);

    // Show cart sidebar on mobile if cart has at least one item
    // with no amount selected.
    if (items.length && isMobile && hasEmptyAmount(items)) {
      openMenu();
    }
  }, [items, isMobile]);

  return (
    <div className="giving-app__content-wrapper coh-container">
      <>
        <h2
          className={`checkout-page__title${
            isLoading ? " spinner--after spinner--medium" : ""
          }`}
        >
          {title}
        </h2>
        <div className="checkout-page">
          <div
            className={`checkout-page__column-1${
              items.length ? " hidden-sm" : ""
            }`}
          >
            {!isMobile ? (
              <DonationList
                setReadyCheckout={setReadyCheckout}
                editStateItems={editStateItems}
                setEditStateItems={setEditStateItems}
                className={`order-item-list--checkout${
                  items.length && items.length > 1 ? " has-multiple-items" : ""
                }`}
              />
            ) : null}

            {(!isLoading && !!items.length && (
              <>
                {!isMobile && webformSubmission ? <WebFormSubmission /> : null}
                <div className="checkout-page__subtotals">
                  <FrequencyToggle
                    frequency={frequency}
                    setFrequency={setFrequency}
                  />
                  <OrderTotal frequency={frequency} total={total} />
                </div>
                <div className="help-box-wrapper">
                  <a
                    className="help-box"
                    href="tel:+14047124483"
                    title="Get help or make your donation by phone"
                  >
                    <h2 className="help-box__title">
                      Have a question? Prefer to make your gift by phone?
                    </h2>
                    <p className="help-box__content">404.712.GIVE (4483)</p>
                  </a>
                </div>
                <div className="checkout-page__add-another">
                  <a
                    className="checkout-page__add-another-button"
                    href={getCampaignPath()}
                    title="Browse our areas of need"
                  >
                    Add Another Gift
                  </a>
                </div>
              </>
            )) ||
              null}
            {(!isLoading && !items.length && (
              <>
                <h1 className="coh-style-heading-5-size">
                  You currently have no items in your cart.
                </h1>
                <p>
                  <a
                    className="coh-style-link-button-with-icon--secondary"
                    href={getCampaignPath()}
                  >
                    Browse our areas of need
                  </a>
                </p>
              </>
            )) ||
              null}
          </div>
          <div
            className={`checkout-page__column-2${
              !items.length ? " hidden-sm" : ""
            }`}
          >
            {checkoutForm}
          </div>
        </div>
      </>
    </div>
  );
};

export default Checkout;
